module.exports = __webpack_public_path__ + "static/lines2-409c554388a798ac4cf8ddde2aadfec0.png";